import {Component, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Router  , ActivatedRoute, ParamMap } from '@angular/router';

import {environment} from '../../../environments/environment';
import {AllCommunityModules} from '@ag-grid-community/all-modules';
//import {AllModules} from '@ag-grid-enterprise/all-modules';
import {BehaviorSubject, Subscription} from 'rxjs';
import { CustomTooltip } from './custom-tooltip.component';
import { AuthService } from '../../auth/auth.service';
import * as _ from 'lodash';
import * as moment from 'moment';
import {RouterLinkCellRendererComponent} from '../../router-link-cell-renderer/router-link-cell-renderer.component';

interface IClassCodeRowData {
  unitName: string;
  state: string;
  postalCode: string;
  experienceMod: number;

  classCode: string;
  baseClassCodeRate?: number;
  classCodeRate?: number;
  classCodeDescription?: string;
  employeeCount: number;
  hazardGroup: string;
  payroll: number;
  manualPremium: number;
}

interface IAcordSubmissionHistory {
  scoreDate: number;
  scoreNumber: number;
  newVenture: number;
  rtsLink: string;
  losshistory: boolean;
}

interface IAcordLossHistory {
  policyYear: string;
  policyStartDate: string;
  policyEndDate: string;
  premiumPaid: number;
  medonlyClaimCount?: number;
  medonlyIncurred?: number;
  indemnityClaimCount?: number;
  indemnityIncurred?: number;
  totalClaimCount: number;
  totalIncurred: number;
}

export class AcordLossHistory implements IAcordLossHistory {
  policyYear: string;
  policyStartDate: string;
  policyEndDate: string;
  premiumPaid: number;
  medonlyClaimCount?: number;
  medonlyIncurred?: number;
  indemnityClaimCount?: number;
  indemnityIncurred?: number;
  totalClaimCount: number;
  totalIncurred: number;

  constructor(yr: number ) {
      this.policyYear = _.toString(yr);
      this.policyStartDate = '';
      this.policyEndDate = '';
      this.premiumPaid = null;
      this.medonlyClaimCount = null;
      this.medonlyIncurred = null;
      this.indemnityClaimCount = null;
      this.indemnityIncurred = null;
      this.totalClaimCount = 0;
      this.totalIncurred = 0;
  }
}

function callRefreshAfterMillis(params, millis, gridApi) {
    setTimeout(() => {
        gridApi.refreshCells(params);
    }, millis);
}

function callResizeAfterMillis(millis, gridApi) {
    setTimeout(() => {
        gridApi.sizeColumnsToFit();
    }, millis);
}

@Component({
  selector: 'app-acord-detail',
  templateUrl: './acord-detail.component.html',
  styleUrls: ['./acord-detail.component.scss']
})
export class AcordDetailComponent implements OnInit, OnDestroy {

  defaultColumDefs = {
    resizable: true,
    sortable: true,
    filter: true,
  };


  unitColumnDefs = [
    // {headerName: 'Name', field: 'unitName', width: 110},
    {headerName: 'Code', field: 'classCode', width: 60, tooltipField: 'classCode',
      tooltipComponent: 'customTooltip'},
    {headerName: 'State', field: 'state', width: 40},
    {headerName: 'EMod', field: 'experienceMod', width: 50, headerTooltip: 'Experience Nodifier'},
    {headerName: 'Rate', field: 'classCodeRate', width: 55, type: 'numericColumn', filter: false, headerTooltip: 'Class Code Rate'},
    {headerName: 'Payroll', field: 'payroll', width: 60, valueFormatter: this.CurrencyFormatter, type: 'numericColumn', filter: false},
    {headerName: 'Employees', field: 'employeeCount', width: 60, headerTooltip: 'Employee Count', type: 'numericColumn', filter: false},
    {headerName: 'Manual Premium', field: 'manualPremium', width: 80,
      headerTooltip: 'Manual Premium based derived from Base Rate and Payroll',
      valueFormatter: this.CurrencyFormatter, type: 'numericColumn', filter: false}
  ];

  submissionColumnDefs = [
    {headerName: ' ', field: 'scoreNumber', width: 100, filter: false, sortable: false,
     headerTooltip: 'Order of the score submission - 1 being the first'},
    {headerName: 'Date', field: 'scoreDate', width: 100, filter: false, sortable: false},
    {headerName: 'Loss History', field: 'losshistory', sortable: false, filter: false,
      width: 120, valueFormatter: this.YesNoFormatter, maxWidth: 120,
      cellStyle: {textAlign: 'center'}}
  ];

  lossHistoryColumnDefs = [
    { headerName: 'Policy', headerTooltip: 'Policy Dates',
      children: [
        { headerName: 'Year',
          field: 'policyYear',
          width: 80,
          headerTooltip: 'Policy Year',
          hide: false,
          editable: true,
          cellEditor: 'agSelectCellEditor',
          filter: false,
          valueParser: this.numberParser,
          cellEditorParams: {
            values: []
          }},
        { headerName: 'Start', field: 'policyStartDate', width: 80, headerTooltip: 'Policy Start Date', hide: true, filter: false },
        { headerName: 'End', field: 'policyEndDate', width: 80, headerTooltip: 'Policy End Date', hide: true, filter: false}
      ]},
    { headerName: '',
      children: [
        {headerName: 'Premium', field: 'premiumPaid', width: 80, headerTooltip: 'Premium paid for the policy period',
          hide: false, valueFormatter: this.CurrencyFormatter, type: 'numericColumn',  editable: true,
          cellEditor: 'numericCellEditor', filter: false},
      ]},
    { headerName: 'Med-Only', headerTooltip: 'Medical Only Claims Information',
      children: [
        {headerName: 'Count', field: 'medonlyClaimCount', width: 80,
          headerTooltip: 'Med-Only Claim Count', hide: false, type: 'numericColumn',  editable: true,
          cellEditor: 'numericCellEditor', onCellValueChanged: this.onCountsChanged, filter: false},
        {headerName: 'Loss', field: 'medonlyIncurred', width: 80, headerTooltip: 'Med-Only Incurred Loss',
          hide: false, valueFormatter: this.CurrencyFormatter, type: 'numericColumn',  editable: true,
          cellEditor: 'numericCellEditor', onCellValueChanged: this.onIncurredChanged, filter: false}
      ]},
    { headerName: 'Indemnity', headerTooltip: 'Indemnity Claims Information',
      children: [
        {headerName: 'Count', field: 'indemnityClaimCount', width: 80,
          headerTooltip: 'Indemnity Claim Count', hide: false, type: 'numericColumn',  editable: true,
          cellEditor: 'numericCellEditor', onCellValueChanged: this.onCountsChanged, filter: false},
        {headerName: 'Loss', field: 'indemnityIncurred', width: 80, headerTooltip: 'Indemnity Incurred Loss',
          hide: false, valueFormatter: this.CurrencyFormatter, type: 'numericColumn',  editable: true,
          cellEditor: 'numericCellEditor', onCellValueChanged: this.onIncurredChanged, filter: false}
      ]},
    { headerName: 'Totals', headerTooltip: 'Total Claims Information',
      children: [
        {headerName: 'Count', field: 'totalClaimCount', width: 80, headerTooltip: 'Total Claim Count',
          hide: false, type: 'numericColumn',  editable: true,
          cellEditor: 'numericCellEditor', filter: false, onCellValueChanged: this.onTotalCountsChanged},
        {headerName: 'Loss', field: 'totalIncurred', width: 80, headerTooltip: 'Total incurred Loss',
          hide: false, valueFormatter: this.CurrencyFormatter, type: 'numericColumn',  editable: true,
          cellEditor: 'numericCellEditor', filter: false, onCellValueChanged: this.onTotalIncurredChanged}
      ]},
  ];


  modules = AllCommunityModules;
  // modules = AllModules;

  // store the api handles for the 3 grids
  classCodeGridApi: any;
  classCodeGridColumnApi: any;
  lossHistoryGridApi: any;
  lossHistoryGridColumnApi: any;
  submissionHistoryGridApi: any;
  submissionHistoryGridColumnApi: any;

  domLayout = 'autoHeight';
  overlayNoRowsTemplate = '<span style=\"padding: 10px;\">New Venture</span>';
  overlayNoScoresTemplate = '<span style=\"padding: 10px;\">No Additional Scores</span>';
  frameworkComponents = {
    routerRenderer: RouterLinkCellRendererComponent,
    customTooltip: CustomTooltip,

  };
  components: any;

  hasLossHistory = false;
  displayType = '';
  account = '';
  maxRank = 10;
  newVenture = false
  showLossHistory = false;
  validated = false;
  validationErrors = [];
  validationWarnings = [];

  isAdmin = new BehaviorSubject<boolean>(false);
  sub: Subscription;
  constructor(private http: HttpClient,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private auth: AuthService) {
    // this.components = { datePicker: this.getDatePicker() };
    this.components = { numericCellEditor: this.getNumericCellEditor() };

    for (let year = new Date().getFullYear(); year >= 2004; year--) {
      this.lossYears.push(year.toString())
    }
    this.lossHistoryColumnDefs[0].children[0]['cellEditorParams'].values = this.lossYears

    this.sub = auth.userProfile$.subscribe(
      user => {
        console.log('Fetching userProfile');
        if (user) {
          const userRoles = user['http://gradientai.com/roles'];
          this.isAdmin.next(_.intersection(['admin'], userRoles).length > 0);
          console.log('admin =' + this.isAdmin.getValue());
        }
      });
  }

  outputJson: any;
  classCodeRowDataSubject$ = new BehaviorSubject<IClassCodeRowData[]>([]);

  lossHistoryRowDataSubject$ = new BehaviorSubject<IAcordLossHistory[]>([]);

  submissionHistoryRowDataSubject$ = new BehaviorSubject<IAcordSubmissionHistory[]>([]);
  dataUrl = '';
  submissionId = null;
  acordResponseId = null;
  fetchSubscription: Subscription;
  rescoreSubscription: Subscription;
  selected = false;
  initialLossHistory: any;
  initialShowLossHistory: any;
  lossYears = [];

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  ngOnInit() {

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {

      console.log(params);
      this.submissionId = params.get('id');
      this.dataUrl = window.location.origin + '/api/uw/wc/get-acord-submission-detail?submission-id=' + this.submissionId;
      this.fetchData(this.dataUrl);
    });
  }
  numberParser(params) {
    return Number(params.newValue);
  }
  fetchData(url) {
    this.fetchSubscription = this.http.get(url).subscribe((data: any[]) => {
      console.log(data);
      this.outputJson = data;
      this.acordResponseId = this.outputJson.submission.responseid;
      const ccd = [];
      for (const iu of this.outputJson.input.InsuredUnits) {

        if ('ClassCodeFactors' in iu) {
          for (const cc of iu.ClassCodeFactors) {
            const row = {} as IClassCodeRowData;
            row.unitName = iu.UnitName;
            row.postalCode = iu.PostalCode;
            row.experienceMod = iu.ExperienceMod;
            row.state = iu.State;
            if ('BaseClassCodeRate' in cc) {
              row.baseClassCodeRate = cc.BaseClassCodeRate;
            } else {
              row.baseClassCodeRate = null;
            }
            if ('ClassCodeRate' in cc) {
              row.classCodeRate = cc.ClassCodeRate;
            } else {
              row.classCodeRate = null;
            }
            if ('ClassCodeDescription' in cc) {
              row.classCodeDescription = cc.ClassCodeDescription;
            } else {
              row.classCodeDescription = '';
            }

            row.classCode = cc.ClassCode;
            row.employeeCount = cc.EmployeeCount;
            row.hazardGroup = cc.HazardGroup;
            row.payroll = cc.Payroll;
            row.manualPremium = cc.ManualPremium;

            ccd.push(row);
          }
        }
      }
      // Submission History
      const submissionHistory = [];
      for (const sh of this.outputJson.history) {
        const row = {} as IAcordSubmissionHistory;
        row.scoreDate = sh.scoredate;
        row.scoreNumber = sh.number;
        row.rtsLink = sh.rtslink;
        row.newVenture = sh.newVenture;
        row.losshistory = sh.losshistory;
        submissionHistory.push(row);
      }

      // Loss History
      let first = true;
      const lossHistory = [];
      for (const lh of this.outputJson.input.LossHistory) {
        const row = {} as IAcordLossHistory;

        if (lh.PolicyYear !== undefined) {
          if (first) {
            this.lossHistoryColumnDefs[0].children[0].hide = false;
            this.lossHistoryColumnDefs[0].children[1].hide = true;
            this.lossHistoryColumnDefs[0].children[2].hide = true;
            first = false;
          }
          row.policyYear = _.toString(lh.PolicyYear);
        } else {
          if (first) {
            this.lossHistoryColumnDefs[0].children[0].hide = true;
            this.lossHistoryColumnDefs[0].children[1].hide = false;
            this.lossHistoryColumnDefs[0].children[2].hide = false;
            first = false;
          }
          row.policyStartDate = lh.PolicyStartDate;
          row.policyEndDate = lh.PolicyEndDate;
        }
        row.premiumPaid = lh.PremiumPaid !== undefined ? lh.PremiumPaid : null;
        row.medonlyClaimCount = lh.MedicalOnly !== undefined ? lh.MedicalOnly.ClaimCount : null;
        row.medonlyIncurred = lh.MedicalOnly !== undefined ? lh.MedicalOnly.Incurred : null;
        row.indemnityClaimCount = lh.Indemnity !== undefined ? lh.Indemnity.ClaimCount : null;
        row.indemnityIncurred = lh.Indemnity !== undefined ? lh.Indemnity.Incurred : null;
        row.totalClaimCount = lh.Total !== undefined ? lh.Total.ClaimCount : null;
        row.totalIncurred = lh.Total !== undefined ? lh.Total.Incurred : null;
        lossHistory.push(row);
      }
      this.newVenture = this.outputJson.newVenture
      this.hasLossHistory = lossHistory.length > 0;
      this.displayType = this.outputJson.displayType;
      this.account = this.outputJson.account;
      if (this.account == 'method') {
        this.maxRank = 5;
      }
      this.showLossHistory = this.hasLossHistory || this.newVenture;
      this.validated = this.outputJson.output.Validation.Status === 'ok';

      if (!this.validated) {
        if (this.validationErrors !== undefined) {
          this.validationErrors = this.outputJson.output.Validation.Error.split('\n');
          if (this.validationErrors.length > 0) {
            this.validationErrors.shift();
          }
        } else {
          this.validationErrors = [];
        }
        this.validationWarnings = this.outputJson.output.Validation.Warning;
        if (this.validationWarnings !== undefined && this.validationWarnings.length > 0) {
          this.validationWarnings.shift();
        }
      }

      this.classCodeRowDataSubject$.next(ccd);
      this.initialLossHistory = _.cloneDeep(lossHistory);
      this.initialShowLossHistory = this.showLossHistory;
      this.lossHistoryRowDataSubject$.next(lossHistory);
      this.submissionHistoryRowDataSubject$.next(submissionHistory);
      console.log(ccd);
      //      this.gridApi.sizeColumnsToFit();

    });
  }
  reloadData() {
    this.fetchData(this.dataUrl);
  }
  rescorePolicy() {
    const url = window.location.origin + '/api/uw/wc/rescore-acord-policy?submission-id=' +
      this.submissionId + '&acord-response-id=' + this.acordResponseId + '&new-venture=' + this.scoreAsNewVenture();

    const body = this.outputJson.input;
    const lossHistory = this.lossHistoryRowDataSubject$.getValue();

    const newLossHistory = [];
    for (const lh of lossHistory) {
      const premium = parseFloat(String(lh.premiumPaid)) || null;
      const row = {
        PolicyYear: _.toNumber(lh.policyYear),
        Total: {
          ClaimCount: parseInt(String(lh.totalClaimCount), 10) || 0,
          Incurred: parseFloat(String(lh.totalIncurred)) || 0
        }
      } as any;

      if (premium !== null) {
        row.PremiumPaid = premium;
      }

      const moClaimCount = parseInt(String(lh.medonlyClaimCount), 10) || null;
      const moIncurred = parseFloat(String(lh.medonlyIncurred)) || null;
      if (moClaimCount || moIncurred) {
        row.MedicalOnly = {
          ClaimCount: moClaimCount || 0,
          Incurred: moIncurred || 0
        };
      }

      const indClaimCount = parseInt(String(lh.indemnityClaimCount), 10) || null;
      const indIncurred = parseFloat(String(lh.indemnityIncurred)) || null;
      if (indClaimCount || indIncurred) {
        row.Indemnity = {
          ClaimCount: indClaimCount || 0,
          Incurred: indIncurred || 0
        };
      }
      newLossHistory.push(row);
    }
    body.LossHistory = newLossHistory;

    this.rescoreSubscription = this.http.post<any>(url, body).subscribe(data => {
      console.log(data);
      const submissionId = data.submissionId;
      if (submissionId === this.submissionId) {
        this.reloadData();
      } else {
        this.router.navigate(['/uw/acord/', submissionId]);
      }
    });
  }
  onFirstDataRendered(event) {
    const colIds = event.columnApi
      .getAllDisplayedColumns()
      .map(col => col.getColId());

    event.columnApi.autoSizeColumns(colIds);
    console.log('autosize');
  }

  onClassCodeGridReady(event) {
    this.classCodeGridApi = event.api;
    this.classCodeGridColumnApi = event.columnApi;
    this.classCodeGridApi.sizeColumnsToFit();
  }

  onLossHistoryGridReady(event) {
    this.lossHistoryGridApi = event.api;
    this.lossHistoryGridColumnApi = event.columnApi;
    this.lossHistoryGridApi.sizeColumnsToFit();
  }

  onSubmissionHistoryGridReady(event) {
    this.submissionHistoryGridApi = event.api;
    this.submissionHistoryGridColumnApi = event.columnApi;
    this.submissionHistoryGridApi.sizeColumnsToFit();
  }
  CurrencyFormatter(params: any) {

    if (params.value !== null && params.value !== '') {
      const usdFormat = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0
      });
      return usdFormat.format(params.value);
    } else {
      return params.value;
    }
  }
  YesNoFormatter(params: any) {

    if (params.data.newVenture) {
      return 'New Venture'
    }
    if (params.value !== null) {
      return params.value ? 'Yes' : 'No';
    } else {
      return params.value;
    }
  }
  onRowClicked(event) {
    this.router.navigate(['/uw/acord/' + event.data.rtsLink]);
  }
  getNewLossYear() {
    const lossHistory = this.lossHistoryRowDataSubject$.getValue();
    const maxYr = new Date().getFullYear() - 1;
    const minYr = maxYr - 20;

    for (let i = maxYr; i >= minYr; i--) {
      let found = false;
      for (const lh of lossHistory) {
        if (lh.policyYear === _.toString(i)) {
          found = true;
          break;
        }
      }
      if (!found) {
        return i;
      }
    }
    return new Date().getFullYear();
  }
  AddLossHistoryRow(event) {
    const lossHistory = this.lossHistoryRowDataSubject$.getValue();
    lossHistory.push(new AcordLossHistory(this.getNewLossYear()));
    this.lossHistoryRowDataSubject$.next(lossHistory);
    this.lossHistoryGridApi.setRowData(lossHistory);
    callResizeAfterMillis(200, this.lossHistoryGridApi);

  }
  fillRange(start, end) {
    const years = [];
    for (let i = end; i >= start; i--) {
      years.push(i);
    }
    return years;
  }
//   getDatePicker() {
//   function Datepicker() {}
//   Datepicker.prototype.init = function(params) {
//     this.eInput = document.createElement('input');
//     this.eInput.value = params.value;
//     $(this.eInput).datepicker({ dateFormat: 'dd/mm/yy' });
//   };
//   Datepicker.prototype.getGui = function() {
//     return this.eInput;
//   };
//   Datepicker.prototype.afterGuiAttached = function() {
//     this.eInput.focus();
//     this.eInput.select();
//   };
//   Datepicker.prototype.getValue = function() {
//     return this.eInput.value;
//   };
//   Datepicker.prototype.destroy = () => {};
//   Datepicker.prototype.isPopup = () => {
//     return false;
//   };
//   return Datepicker;
// }

  getNumericCellEditor() {
    function isCharNumeric(charStr) {
      return !!/\d/.test(charStr);
    }
    function isKeyPressedNumeric(event) {
      const charCode = getCharCodeFromEvent(event);
      const charStr = String.fromCharCode(charCode);
      return isCharNumeric(charStr);
    }
    function getCharCodeFromEvent(event) {
      event = event || window.event;
      return typeof event.which === 'undefined' ? event.keyCode : event.which;
    }
    function NumericCellEditor() {}
    NumericCellEditor.prototype.init = function(params) {
      this.focusAfterAttached = params.cellStartedEdit;
      this.eInput = document.createElement('input');
      this.eInput.style.width = '100%';
      this.eInput.style.height = '100%';
      this.eInput.value = isCharNumeric(params.charPress) ? params.charPress : params.value;
      const that = this;
      this.eInput.addEventListener('keypress', (event) => {
        if (!isKeyPressedNumeric(event)) {
          that.eInput.focus();
          if (event.preventDefault) {
            event.preventDefault();
          }
        }
      });
    };
    NumericCellEditor.prototype.getGui = function() {
      return this.eInput;
    };
    NumericCellEditor.prototype.afterGuiAttached = function() {
      if (this.focusAfterAttached) {
        this.eInput.focus();
        this.eInput.select();
      }
    };
    NumericCellEditor.prototype.isCancelBeforeStart = function() {
      return this.cancelBeforeStart;
    };
    NumericCellEditor.prototype.isCancelAfterEnd = () => {};
    NumericCellEditor.prototype.getValue = function() {
      return (this.eInput.value === '') ? null : Number(this.eInput.value);
    };
    NumericCellEditor.prototype.focusIn = function() {
      const eInput = this.getGui();
      eInput.focus();
      eInput.select();
      console.log('NumericCellEditor.focusIn()');
    };
    NumericCellEditor.prototype.focusOut = () => {
      console.log('NumericCellEditor.focusOut()');
    };
    return NumericCellEditor;
  }

  onCountsChanged(params) {
    const nv = parseInt(params.newValue, 10) || 0;
    const ov = parseFloat(params.oldValue) || 0;
    if (ov !== nv) {
      params.data.totalClaimCount = (parseInt(params.data.medonlyClaimCount, 10) || 0) +
        (parseInt(params.data.indemnityClaimCount, 10) || 0);

      const refreshParams = {
        columns: ['totalClaimCount']
      };
      callRefreshAfterMillis(refreshParams, 100, params.api);
    }
  }
  onIncurredChanged(params) {
    const nv = parseFloat(params.newValue) || 0;
    const ov = parseFloat(params.oldValue) || 0;
    if (ov !== nv) {
      params.data.totalIncurred = (parseFloat(params.data.medonlyIncurred) || 0) +
        (parseFloat(params.data.indemnityIncurred) || 0);

      const refreshParams = {
        columns: ['totalIncurred']
      };

      callRefreshAfterMillis(refreshParams, 100, params.api);
    }
  }
  onTotalCountsChanged(params) {
    const nv = parseInt(params.newValue, 10) || 0;
    const ov = parseFloat(params.oldValue) || 0;
    if (ov !== nv) {
      params.data.medonlyClaimCount = '';
      params.data.indemnityClaimCount = '';

      const refreshParams = {
        columns: ['medonlyClaimCount', 'indemnityClaimCount']
      };
      callRefreshAfterMillis(refreshParams, 100, params.api);
    }
  }
  onTotalIncurredChanged(params) {
    const nv = parseFloat(params.newValue) || 0;
    const ov = parseFloat(params.oldValue) || 0;
    if (ov !== nv) {
      params.data.medonlyIncurred = '';
      params.data.indemnityIncurred = '';

      const refreshParams = {
        columns: ['medonlyIncurred', 'indemnityIncurred']
      };
      callRefreshAfterMillis(refreshParams, 100, params.api);
    }
  }
  onRowSelected(event) {
    this.selected = this.lossHistoryGridApi.getSelectedNodes().length > 0;
  }
  RemoveLossHistoryRow(event) {
    const selectedData = this.lossHistoryGridApi.getSelectedRows();
    const res = this.lossHistoryGridApi.updateRowData({ remove: selectedData });
    const lossHistory = this.lossHistoryRowDataSubject$.getValue();
    lossHistory.splice(lossHistory.indexOf(selectedData[0]), 1);

    this.selected = false;
  }
  onLossHistoryClicked(event) {
    const lossHistory = this.lossHistoryRowDataSubject$.getValue();
    if (lossHistory.length > 0 && !event.target.checked) {
      if (!confirm('Remove Loss History ?')) {
        event.preventDefault();
      } else {
        this.lossHistoryRowDataSubject$.next([]);
      }
    }
  }
  isDirty() {
    if (this.initialLossHistory === undefined) {
      return false;
    }
    const lossHistory = this.lossHistoryRowDataSubject$.getValue();
    return !_.isEqual(lossHistory, this.initialLossHistory) || this.initialShowLossHistory != this.showLossHistory;
  }
  scoreAsNewVenture() {
    const lossHistory = this.lossHistoryRowDataSubject$.getValue();
    return lossHistory.length == 0 && this.showLossHistory;
  }
}
